import { MeasurementTool } from '@technology/web3d-plugin-markup';
import { Web3DViewerWrapper } from '@trimble/web3d-utils';
import {
  MeasurementsCapabilityProvider,
  Web3dTool,
} from '@trimble/web3d-providers';
import { Accessor, createSignal } from 'solid-js';
import { SimpleMeasurementCapabilityBase } from './base-simple-measurement-capability';
import { LineMeasurementConstraint } from './line-measurement.types';

export class LineMeasurementCapability extends SimpleMeasurementCapabilityBase {
  protected measurementType: Web3dTool = Web3dTool.LineMeasurement;

  public readonly constraint: Accessor<LineMeasurementConstraint>;
  private readonly setConstraintValue: (
    constraint: LineMeasurementConstraint
  ) => void;

  constructor(measurementsProvider: MeasurementsCapabilityProvider) {
    super(measurementsProvider);
    const [constraint, setConstraint] = createSignal(
      LineMeasurementConstraint.Free
    );
    this.constraint = constraint;
    this.setConstraintValue = setConstraint;
  }

  public setConstraint(constraint: LineMeasurementConstraint): void {
    this.setConstraintValue(constraint);
    this.applyConstraint(this.viewerWrappers());
  }

  protected override async setupWeb3dMeasurementTool(
    viewerWrappers: Web3DViewerWrapper[]
  ): Promise<void> {
    await super.setupWeb3dMeasurementTool(viewerWrappers);
    this.applyConstraint(viewerWrappers);
  }

  private applyConstraint(viewerWrappers: Web3DViewerWrapper[]): void {
    const vertical = this.constraint() === LineMeasurementConstraint.ConstrainZ;

    for (const viewerWrapper of viewerWrappers) {
      const measurementTool = viewerWrapper.viewer.tools.get(MeasurementTool);
      if (measurementTool) {
        measurementTool.verticalConstraint = vertical;
      }
    }
  }
}
